module.exports = __webpack_public_path__ + "img/modern_calligraphy.53adf80c.jpg";